import { animated } from '@react-spring/web'
import { useCallback, useContext, useMemo } from 'react'

import { useBlinkingState } from '../../../lib/preview-animation-hook'
import { type StepDefinitionProps } from '../../../lib/step-definition'
import { FrameBuilderStringsContext } from '../../../contexts/strings-context'
import { FrameBuilderValidationContext } from '../../../contexts/validation-context'

import Button from '../../utility/button'
import Link from '../../utility/link'
import ListContainer from '../../utility/list-container'
import PortableText from '../../utility/portable-text'
import ConfigurationDefinition from '../configuration-definition'
import ProfileList from './profile-list'

const FrameStyleDefinition = ({
  number,
  onClose,
  className,
}: StepDefinitionProps) => {
  const { validationMessages } = useContext(FrameBuilderValidationContext)
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)

  const [profileOpacity, setIsProfileBlinking] = useBlinkingState()

  // TODO: Wrong way to check for valid state!
  const isValidSelection = useMemo(
    () =>
      !validationMessages?.frameStyleProfilePreview &&
      !validationMessages?.frameStyleTexturePreview,
    [validationMessages],
  )

  const handleOkClick = useCallback(() => {
    if (isValidSelection) {
      onClose()
    }

    if (!isValidSelection) {
      setIsProfileBlinking(true)
    }
  }, [isValidSelection, setIsProfileBlinking, onClose])

  return (
    <ConfigurationDefinition
      number={number}
      onClose={onClose}
      title={frameBuilderStrings.frameStyleStepTitle}
      className={className}
    >
      <div className="flex flex-col px-6 space-y-6">
        <animated.div
          style={{
            opacity: profileOpacity,
          }}
        >
          <ListContainer gapSize="sm">
            <ProfileList />
          </ListContainer>

          {frameBuilderStrings.frameStyleProfileReadMore &&
            frameBuilderStrings.frameStyleProfileReadMoreUrl && (
              <Link
                link={{
                  url: frameBuilderStrings.frameStyleProfileReadMoreUrl,
                }}
                className="block text-xs"
              >
                {frameBuilderStrings.frameStyleProfileReadMore}
              </Link>
            )}
        </animated.div>

        <div className="flex justify-between mt-6">
          <Button
            size="small"
            isVisuallyDisabled={!isValidSelection}
            onClick={handleOkClick}
            className="w-[49%] grow-0 shrink-0"
          >
            {frameBuilderStrings.controlOkLabel}
          </Button>
        </div>
      </div>

      {frameBuilderStrings.frameStyleStepFooter && (
        <>
          <hr className="bg-gray-300" />
          <div className="flex flex-col px-6 space-y-6">
            <PortableText content={frameBuilderStrings.frameStyleStepFooter} />
          </div>
        </>
      )}
    </ConfigurationDefinition>
  )
}

export default FrameStyleDefinition
